import { Logo } from "@/components/Logo";

export function NotFound() {
  return (
    <div className="min-h-screen flex flex-col">
      <header className="px-6 py-4">
        <Logo />
      </header>
      <main className="flex-1 flex items-center justify-center p-6">
        <div className="card p-8 max-w-md text-center">
          <div className="text-3xl font-extrabold text-midnight mb-2">Not found</div>
          <p className="text-grape">
            This page doesn't exist. If you received a BDR submission link, please open it
            directly from your email — do not copy just the domain.
          </p>
        </div>
      </main>
    </div>
  );
}
